<template>
  <div>
    <div class="filter-wrapper">
      <div class="filter-options">
        <v-row>
          <v-col cols="12">
            <GradeClassStudentSelect @changed="gradeClassStudentChange" />
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12" md="4">
            <DateIOSPicker
              label="Từ ngày"
              outlined
              dense
              outline
              :date.sync="dateFrom"
              @onEnterPress="onFilterChanged"
            />
          </v-col>
          <v-col cols="12" md="4">
            <DateIOSPicker
              label="Đến ngày"
              outlined
              dense
              hide-details
              outline
              :date.sync="dateTo"
              @onEnterPress="onFilterChanged"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="status"
              item-text="title"
              item-value="value"
              label="Trạng thái"
              :items="smsStatuses"
              outlined
              clearable
              dense
              hide-details
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mt-3" v-if="advanceSearch">
          <v-col cols="12" md="4">
            <v-select
              v-model="postType"
              item-text="title"
              item-value="value"
              label="Dạng tin"
              :items="postTypes"
              outlined
              clearable
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="config"
              item-text="title"
              item-value="value"
              :items="postConfigs"
              label="Loại tin gửi"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="postToType"
              item-text="title"
              item-value="value"
              label="Đối tượng nhận"
              :items="postToTypes"
              outlined
              clearable
              dense
              hide-details
            ></v-select>
          </v-col>
        </v-row>
      </div>
      <div class="filter-submit">
        <v-btn class="search-button" height="40" outlined color="#0D47A1" @click="onFilterChanged">
          Tìm kiếm
        </v-btn>
      </div>
    </div>
    <v-row class="mt-0">
      <v-col cols="12" class="d-flex justify-end">
        <div @click="advanceSearch = !advanceSearch" class="advance-search primary--text">
          {{ advanceSearchText }}
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import get from 'lodash-es/get'
import moment from 'moment'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker'

export default {
  components: { GradeClassStudentSelect, DateIOSPicker },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    postType: '',
    postToType: '',
    receiver: null,
    config: '',
    dateFrom: '',
    dateTo: '',
    advanceSearch: false,
    status: '',
    dateData_gte: '',
    dateData_lte: ''
  }),
  computed: {
    ...mapGetters('constant', ['postTypes', 'smsStatuses', 'postToTypes', 'postConfigs']),
    advanceSearchText() {
      return this.advanceSearch ? 'Ẩn tìm kiếm nâng cao' : 'Chọn tìm kiếm nâng cao'
    }
  },
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      if (this.dateFrom && this.dateTo) {
        this.dateData_gte = moment(this.dateFrom)
          .startOf('day')
          .toISOString()
        this.dateData_lte = moment(this.dateTo)
          .endOf('day')
          .toISOString()
      } else if (this.dateFrom) {
        this.dateData_gte = moment(this.dateFrom)
          .startOf('day')
          .toISOString()
        this.dateData_lte = moment().toISOString()
      } else if (this.dateTo) {
        this.dateData_lte = moment(this.dateTo)
          .endOf('day')
          .toISOString()
      }

      const params = {
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        student: get(this.selectedStudent, 'id'),
        createdAt_gte: this.dateData_gte,
        createdAt_lte: this.dateData_lte,
        status: this.status,
        postType: this.postType,
        postToType: this.postToType
      }

      if (this.config === 'auto') params.config_ne = 'immediately'
      else params.config = this.config

      this.$emit('onFilterChanged', { ...params })
    }
  }
}
</script>

<style lang="scss" scoped>
.advance-search {
  white-space: nowrap;
  cursor: pointer;
}
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
